enum GlobalServiceEnum {
    globalServiceTitle = "globalService.title",
    globalServiceDesc = "globalService.desc"

}
export default GlobalServiceEnum